import PropTypes from 'prop-types';
import { Skeleton } from 'src/features/tyre-management/components/ui/skeleton';

const cells = [
  ['matching', 'Matching'],
  ['active', 'Active'],
  ['tyre_management_enabled', 'Tyre tracking on'],
  ['tyre_unconfigured', 'Need tyre setup'],
];

const displayValue = (key, aggregates, globalEnabled) => {
  if (key === 'tyre_unconfigured' && !globalEnabled) return 'Unavailable';
  const value = aggregates?.[key];
  if (value === null || value === undefined) return 'Unavailable';
  return value;
};

const FleetStrip = ({
  aggregates, loading, globalEnabled, onOpenUnconfigured,
}) => (
  <div className="vl-fleet-strip" aria-label="Fleet scope">
    {cells.filter(([key]) => globalEnabled || !key.startsWith('tyre_')).map(([key, label]) => {
      const actionable = key === 'tyre_unconfigured' && onOpenUnconfigured && !loading;
      const Cell = actionable ? 'button' : 'div';
      return (
      <Cell
        key={key}
        type={actionable ? 'button' : undefined}
        className={`vl-fleet-strip__cell${actionable ? ' vl-fleet-strip__cell--action' : ''}`}
        onClick={actionable ? onOpenUnconfigured : undefined}
      >
        <p className="vl-fleet-strip__label">{label}</p>
        {loading ? (
          <Skeleton height={22} width={48} />
        ) : (
          <p className="vl-fleet-strip__value">{displayValue(key, aggregates, globalEnabled)}</p>
        )}
        {actionable && <span className="vl-fleet-strip__hint">Open setup</span>}
      </Cell>
      );
    })}
  </div>
);

FleetStrip.propTypes = {
  aggregates: PropTypes.object,
  loading: PropTypes.bool,
  globalEnabled: PropTypes.bool,
  onOpenUnconfigured: PropTypes.func,
};

export default FleetStrip;
